import { assertAA } from './contrast.js';
import { tokens } from './tokens.js';
/** AA pary pro jednu sadu hodnot (svetla nebo tmava) - sdileno mezi obema schematy. */
function aaPairsFor(v, label) {
    return [
        [v.text, v.card, `${label}: text/card`],
        [v.text, v.canvas, `${label}: text/canvas`],
        [v.textMuted, v.card, `${label}: textMuted/card`],
        [v.textMuted, v.canvas, `${label}: textMuted/canvas`],
        [v.accentText, v.accent, `${label}: accentText/accent`],
        [v.accent, v.card, `${label}: accent/card (odkazy)`],
        [v.success, v.successBg, `${label}: success/successBg`],
        [v.warning, v.warningBg, `${label}: warning/warningBg`],
        [v.danger, v.dangerBg, `${label}: danger/dangerBg`],
        // UI komponenty (3:1): akcent proti platnu (ohraniceni, fokus ring)
        [v.accent, v.canvas, `${label}: accent/canvas (UI)`, 3],
    ];
}
function lightValues(t) {
    return {
        accent: t.accent,
        accentText: t.accentText,
        canvas: t.canvas,
        card: t.card,
        text: t.text,
        textMuted: t.textMuted,
        success: t.success,
        successBg: t.successBg,
        warning: t.warning,
        warningBg: t.warningBg,
        danger: t.danger,
        dangerBg: t.dangerBg,
    };
}
function darkValues(t, dark) {
    return {
        accent: dark.accent ?? t.accent,
        accentText: dark.accentText ?? t.accentText,
        canvas: dark.canvas,
        card: dark.card,
        text: dark.text,
        textMuted: dark.textMuted,
        success: dark.success ?? t.success,
        successBg: dark.successBg,
        warning: dark.warning ?? t.warning,
        warningBg: dark.warningBg,
        danger: dark.danger ?? t.danger,
        dangerBg: dark.dangerBg,
    };
}
function cssBlock(selector, vars) {
    const body = vars.map(([k, v]) => `  ${k}: ${v};`).join('\n');
    return `${selector} {\n${body}\n}`;
}
/**
 * Kompilace tematu do CSS custom properties pod [data-theme="name"] +
 * [data-theme="name"][data-scheme="dark"]. Hazi chybu (fail-fast) pri
 * poruseni AA na KTEREKOLI sade — tema (svetle i tmave) se nesmi dostat do
 * buildu bez prochoziho kontrastu.
 */
export function compileTheme(t) {
    assertAA(aaPairsFor(lightValues(t), t.name));
    const lightVars = [
        ['--rh-accent', t.accent],
        ['--rh-accent-text', t.accentText],
        ['--rh-accent-soft', t.accentSoft],
        ['--rh-canvas', t.canvas],
        ['--rh-card', t.card],
        ['--rh-border', t.border],
        ['--rh-text', t.text],
        ['--rh-text-muted', t.textMuted],
        ['--rh-success', t.success],
        ['--rh-success-bg', t.successBg],
        ['--rh-warning', t.warning],
        ['--rh-warning-bg', t.warningBg],
        ['--rh-danger', t.danger],
        ['--rh-danger-bg', t.dangerBg],
        ['--rh-shadow-menu', t.shadowMenu ?? 'rgb(22 24 29 / 0.12)'],
        ['--rh-chart-1', t.chart[0]],
        ['--rh-chart-2', t.chart[1]],
        ['--rh-chart-3', t.chart[2]],
        ['--rh-chart-4', t.chart[3]],
        ['--rh-chart-5', t.chart[4]],
        ['--rh-radius-control', tokens.radius.control],
        ['--rh-radius-card', tokens.radius.card],
        ['--rh-radius-shell', tokens.radius.shell],
        ['--rh-font-sans', tokens.typography.fontSans],
    ];
    const blocks = [cssBlock(`[data-theme="${t.name}"]`, lightVars)];
    if (t.dark) {
        const dark = t.dark;
        assertAA(aaPairsFor(darkValues(t, dark), `${t.name}: dark`));
        const darkVars = [
            ['--rh-accent', dark.accent ?? t.accent],
            ['--rh-accent-text', dark.accentText ?? t.accentText],
            ['--rh-accent-soft', dark.accentSoft],
            ['--rh-canvas', dark.canvas],
            ['--rh-card', dark.card],
            ['--rh-border', dark.border],
            ['--rh-text', dark.text],
            ['--rh-text-muted', dark.textMuted],
            ['--rh-success', dark.success ?? t.success],
            ['--rh-success-bg', dark.successBg],
            ['--rh-warning', dark.warning ?? t.warning],
            ['--rh-warning-bg', dark.warningBg],
            ['--rh-danger', dark.danger ?? t.danger],
            ['--rh-danger-bg', dark.dangerBg],
            ['--rh-shadow-menu', dark.shadowMenu ?? 'rgb(0 0 0 / 0.4)'],
        ];
        blocks.push(cssBlock(`[data-theme="${t.name}"][data-scheme="dark"]`, darkVars));
    }
    return blocks.join('\n\n');
}
//# sourceMappingURL=compile.js.map